import { Skeleton } from "../../../../core/ui";
import "./CoastMediaPlayer.style.scss";

export const CoastMediaPlayerSkeleton = () => (
  <div className="component-coast-media-player skeleton">
    <figure>
      <div className="player-container">
        <Skeleton pulse={true} type="image" name="main image" shape="16x9" />
      </div>
      <figcaption>
        <Skeleton pulse={true} type="text" name="Title" size={3} />
      </figcaption>
    </figure>
  </div>
);
